export default __webpack_public_path__ + "6ed991198071a7a792925bc4d27482ff.svg";